import { Component } from '@theme/component';
import { Fleet, selfHeal, shopUrl } from '@theme/fleet';

/**
 * <fleet-context-bar> — a slim site-wide bar showing the active machine so the
 * shopper's context follows them as they browse. Hidden by CSS until JS reveals
 * it (active machine exists AND not dismissed this session), so the common
 * no-active-machine case causes zero layout shift.
 */

const DISMISS_KEY = 'fleet:ctxbar-dismissed';

class FleetContextBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.labelEl = this.querySelector('[data-ref="label"]');
    this.shopLink = this.querySelector('[data-ref="shop"]');

    this.render = this.render.bind(this);
    // Render + self-heal against Horizon's post-paint section morph.
    this._heal = selfHeal(this, this.render);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._heal) this._heal.stop();
  }

  #dismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch (_) {
      return false;
    }
  }

  dismiss() {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (_) {
      /* private mode — bar reappears next load, acceptable */
    }
    this.removeAttribute('data-shown');
  }

  change() {
    const menu = document.querySelector('fleet-menu');
    if (menu && typeof menu.open === 'function') menu.open();
  }

  render() {
    const active = Fleet.getActive();
    if (!active || this.#dismissed()) {
      this.removeAttribute('data-shown');
      return;
    }
    if (this.labelEl) this.labelEl.textContent = active.label;
    if (this.shopLink) this.shopLink.setAttribute('href', shopUrl(active));
    this.setAttribute('data-shown', '');
  }
}

if (!customElements.get('fleet-context-bar')) customElements.define('fleet-context-bar', FleetContextBar);
